export default function setAlphaInRgba (originalRgba, newAlpha) {
    return originalRgba.substring(0, 7) + Math.floor(newAlpha * 255).toString(16);
}
